export { default as FoundationDonation } from './pages/FoundationDonation';
